function loadKknTematik(view) {
    return () => import( /* webpackChunkName: "kknTematik-[request]" */ `../../views/KampusMerdeka/KknTematik/${view}.vue`)
}
function loadBimbinganKknTematik(view) {
    return () => import( /* webpackChunkName: "bimbinganKknTematik-[request]" */ `../../views/KampusMerdeka/BimbinganKknTematik/${view}.vue`)
}

const kknTematikRoute = [
    {
        path: '/kampus-merdeka/kkn-tematik',
        name: 'KknTematikMahasiswaView',
        meta: {
            requiresAuth: true,
            roleVerif: false,
            role: []
        },
        component: loadKknTematik('MahasiswaView')
    },
    {
        path: '/kampus-merdeka/kkn-tematik-verify',
        name: 'KknTematikVerifyView',
        meta: {
            requiresAuth: true,
            roleVerif: false,
            role: []
        },
        component: loadKknTematik('KknTematikVerifyView')
    },
    {
        path: '/kkn-tematik-logbook/:id',
        name: 'LogbookKknTematik',
        meta: {
            requiresAuth: true,
            roleVerif: false,
            role: []
        },
        component: loadKknTematik('LogbookKknTematik')
    },
    {
        path: '/kkn-tematik-dosbim/:detail_id',
        name: 'DosbimKknTematik',
        meta: {
            requiresAuth: true,
            roleVerif: false,
            role: []
        },
        component: loadKknTematik('KknTematikAdvisor')
    },
    {
        path: '/kkn-tematik-rubric',
        name: 'RubricKknTematik',
        meta: {
            requiresAuth: true,
            roleVerif: true,
            role: ['kaprodi','sekprodi']
        },
        component: loadKknTematik('RubricCategory')
    },
    {
        path: '/kkn-tematik-rubric/:category_id',
        name: 'RubricFieldKknTematik',
        meta: {
            requiresAuth: true,
            roleVerif: true,
            role: ['kaprodi','sekprodi']
        },
        component: loadKknTematik('RubricField')
    },
    {
        path: '/kkn-tematik-exam/:id',
        meta: {
            requiresAuth: true,
            roleVerif: false,
            role: []
        },
        component: loadKknTematik('MainViewExam'),
        children: [
            {
                path: '',
                name: 'Ujian Kkn Tematik',
                component: loadKknTematik('ExamDetail')
            },
            {
                path: 'desa',
                name: 'Penilaian Desa',
                component: loadKknTematik('InstitusiRubric')
            },
            {
                path: 'lecture',
                name: 'Penilaian Dosen Pembimbing Kkn Tematik',
                component: loadKknTematik('LectureRubric')
            },
            {
                path: 'result',
                name: 'Nilai Kkn Tematik',
                component: loadKknTematik('KknTematikResult')
            }
        ]
    },
    {
        path: '/kampus-merdeka/dosen/bimbingan/kkn-tematik/:student_id',
        name: 'MyStudentGuidancesKknTematik',
        meta: {
            requiresAuth: true,
            roleVerif: true,
            role: ['kaprodi','administrator','sekprodi','dosen', 'kalab', 'wadek', 'kadep']
        },
        component: loadBimbinganKknTematik('ListBimbinganMahasiswa')
    },
    {
        path: '/kampus-merdeka/dosen/bimbingan/kkn-tematik',
        name: 'MyGuidanceStudentsKknTematik',
        meta: {
            requiresAuth: true,
            roleVerif: true,
            role: ['kaprodi','administrator','sekprodi','dosen', 'kalab', 'wadek', 'kadep']
        },
        component: loadBimbinganKknTematik('ListMahasiswaBimbingan')
    },
    {
        path: '/kampus-merdeka/dosen/bimbingan/kkn-tematik/:student_id/:guidance_id',
        name: 'ResponseMyStudentGuidanceKknTematik',
        meta: {
            requiresAuth: true,
            roleVerif: true,
            role: ['kaprodi','administrator','sekprodi','dosen', 'kalab', 'wadek', 'kadep']
        },
        component: loadBimbinganKknTematik('ResponseBimbinganMahasiswa')
    },
    {
        path: '/kampus-merdeka/mahasiswa/bimbingan/kkn-tematik/:guidance_id',
        name: 'ResponseGuidanceKknTematik',
        meta: {
            requiresAuth: true,
            roleVerif: true,
            role: ['mahasiswa']
        },
        component: loadBimbinganKknTematik('ResponseBimbinganMahasiswa')
    },
    {
        path: '/kampus-merdeka/mahasiswa/bimbingan/kkn-tematik',
        name: 'ListBimbinganKknTematik',
        meta: {
            requiresAuth: true,
            roleVerif: true,
            role: ['mahasiswa']
        },
        component: loadBimbinganKknTematik('ListBimbingan')
    },
    {
        path: '/kampus-merdeka/form/bimbingan/kkn-tematik',
        name: 'FormBimbinganKknTematik',
        meta: {
            requiresAuth: true,
            roleVerif: true,
            role: ['mahasiswa']
        },
        component: loadBimbinganKknTematik('FormBimbingan')
    },
    {
        path: '/kkn-tematik-exam',
        name: 'KknTematikVerifyExam',
        meta: {
            requiresAuth: true,
            roleVerif: true,
            role: ['kaprodi','administrator','sekprodi','dosen', 'kalab', 'wadek', 'kadep']
        },
        component: loadKknTematik('VerifyExam')
    },
    {
        path: '/konversi-kkn-tematik',
        name: 'StudentConvertionViewKknTematik',
        meta: {
            requiresAuth: true,
            roleVerif: true,
            role: ['kaprodi','administrator','sekprodi']
        },
        component: loadKknTematik('StudentConvertionView')
    },
    {
        path: '/konversi-kkn-tematik/mata-kuliah/:id',
        name: 'ConvertionViewKknTematik',
        meta: {
            requiresAuth: true,
            roleVerif: true,
            role: ['kaprodi','sekprodi']
        },
        component: loadKknTematik('ConvertionView')
    },
    {
        path: '/konversi-kkn-tematik/mata-kuliah/:id/TU',
        name: 'ConvertionViewKknTematikAdmin',
        meta: {
            requiresAuth: true,
            roleVerif: true,
            role: ['administrator', 'mahasiswa']
        },
        component: loadKknTematik('ConvertionViewAdmin')
    },
]

export default kknTematikRoute